import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const node = document.getElementById('root');

if (node) {
	const root = ReactDOM.createRoot(node);
	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);
}
